import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { LayoutService } from './core/services/layout.service';
import { Layout } from './shared/models/layout.model';
import { AuthService } from './core/services/auth.service';
import { InterceptorMessageService } from './core/interceptor/interceptor.message.service';
import { AuthGuardMessageService } from './core/guards/auth-guard.message.service';
import { Router, Route } from '@angular/router';
import { routes } from './app-routing.module';
import { StoreService, StoreKeys } from './core/store/ngrx-store.service';
import { registerLocaleData } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'configuration';
  layout: Layout = {
    pageHeader: {
      pageTitle: '',
      pageIcon: '',
      iconLink: '',
      confirmDialogRequired: false,
    },
    breadcrumbItems: []
  } as Layout;
  loading = true;
  openAccessDeniedDialog = false;
  hideProductContent = true;
  isUserDataLoaded = false;

  constructor(
    private layoutService: LayoutService,
    private cdr: ChangeDetectorRef,
    public authService: AuthService,
    private interceptorMsgService: InterceptorMessageService,
    private authGuardMsgService: AuthGuardMessageService,
    private router: Router,
    private storeService: StoreService
  ) {

    this.interceptorMsgService.isLoading.subscribe(data => {
      this.loading = data;
    });

    this.authGuardMsgService.userDeniedPermission.subscribe((data: boolean) => {
      this.openAccessDeniedDialog = data;
      this.hideProductContent = data;
    });

    this.authService.isUserDataLoaded$.subscribe((s) => {
      this.isUserDataLoaded = s;
      this.router.navigate(['']);
    });
  }

  ngOnInit() {
    this.layoutService.layoutChanges.subscribe((layout: Layout) => {
      this.layout = layout;
      this.cdr.detectChanges();
    });

    const pathName = window.location.pathname;
    if (pathName.match(/^\/\S+\/\S+/)) {
      this.navigateToModuleDefaultPage(pathName.split('/'));
    }
  }

  navigateToModuleDefaultPage(paths: string[]): void {
    // Checking for each path as we included /dev in for develop branch
    for (const path of paths) {
      const isRouteFound = routes.some((route: Route) => route.path === path);
      if (isRouteFound) {
        this.router.navigate([path]);
      }
    }
  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  closeErrorDialog() {
    this.openAccessDeniedDialog = false;
    this.storeService.Get(StoreKeys.UserDetails).subscribe(userDetails => {
      if (userDetails.hasProductManagementPermission) {
        // User doesn't have ProductManagement Permission
        this.router.navigate(['']);
      }
    });
  }
}
